/**
 * Client-side session state carried between scenes — the slice-1 equivalent of
 * the prototype's `App` React state (`docs/design/flow/app.jsx`). Holds the
 * player's chosen identity from the Splash screen and (slice 2) the room the
 * player is currently entering. Server-synced room *state* lives on the live
 * Colyseus room (`client/src/net/client.ts`), not here — this only carries the
 * minimal scene handoff (which code/name we just joined).
 */

import { DEFAULT_COSTUME, type PlayerProfile } from '@ponponland/shared';

/** Mutable per-tab session. Default matches the prototype's initial player. */
export const session: {
  player: PlayerProfile;
  /** The room being entered (code + name) — set on create/join, read by Lobby. */
  room: { code: string; name: string } | null;
} = {
  player: { name: 'Jelly', costume: DEFAULT_COSTUME },
  room: null,
};
